export function formatarValorMonetario(valorMonetario: number): string {
  return valorMonetario.toLocaleString("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}
export function formatarData(data: Date): string {
  return data && new Date(data).toLocaleDateString("pt-BR");
}

export function formatarDataString(data: string): string {
  return data && new Date(data.concat("T00:00:00")).toLocaleDateString("pt-BR");
}
export function formatarDataStringParaMesAno(data: string): string {
  const splitData = data.split("-");
  const ano = splitData[0];
  const mes = splitData[1];
  const dataFormatada = `${mes}/${ano}`;
  return dataFormatada;
}

export function formatarDataParaGetRequest(data: Date | null | undefined) {
  const dataObj = data ? new Date(data) : null;
  if (!dataObj || isNaN(dataObj.getTime())) {
    return undefined;
  }

  return dataObj.toISOString().split("T")[0];
  
}

export function formatarHorarioParaHoraMinuto(horario: string): string {
  const horarioOriginal = horario;
  const horaMinuto = horarioOriginal.split(":");
  const horarioFormatado = horaMinuto[0] + ":" + horaMinuto[1];
  return horarioFormatado;
}

export function formatarDateParaLocalTime(data: Date): string {
  let hora = data.getHours();
  let minuto = data.getMinutes();
  let segundo = data.getSeconds();
  return `${hora.toString().padStart(2, "0")}:${minuto.toString().padStart(2, "0")}:${segundo
    .toString()
    .padStart(2, "0")}`;
}

export function criarDataByLocalDateAndLocalTimeString(localDate: string, localTime: string): Date {
  const [hora, minuto, segundos] = localTime.split(":").map(Number);
  const data = new Date(localDate.concat("T00:00:00"));
  data.setHours(hora);
  data.setMinutes(minuto);
  data.setSeconds(segundos);

  return data;
}

export function criarDataByLocalDate(localDate: string): Date {
  return new Date(localDate.concat("T00:00:00"));
}

export function removerCaracteresEspeciais(valor: string): string {
  return valor.replace(/[^a-zA-Z0-9]/g, "");
}

export function getDataFormatadaParaVisualizacao(data: Date | null): string {
  let dataFormatada = "";
  if (data) {
    const dia = data.getDate();
    const mes = data.getMonth() + 1;
    const ano = data.getFullYear();

    const diaFormatado = dia < 10 ? `0${dia}` : `${dia}`;
    const mesFormatado = mes < 10 ? `0${mes}` : `${mes}`;
    dataFormatada = `${diaFormatado} / ${mesFormatado} / ${ano}`;
  }
  return dataFormatada;
}

export function getMesCompetenciaParaVisualizacao(data: Date | null): string {
  let dataFormatada = "";
  if (data) {
    const dia = data.getDate();
    const mes = data.getMonth() + 1;
    const ano = data.getFullYear();

    const diaFormatado = dia < 10 ? `0${dia}` : `${dia}`;
    const mesFormatado = mes < 10 ? `0${mes}` : `${mes}`;
    dataFormatada = `${mesFormatado} / ${ano}`;
  }
  return dataFormatada;
}

export function getHorarioFormatadoParaVisualizacao(data: Date | null): string {
  let horarioFormatado = "";
  if (data) {
    const horas = data.getHours();
    const minutos = data.getMinutes();
    const horaFormatada = horas < 10 ? `0${horas}` : `${horas}`;
    const minutoFormatado = minutos < 10 ? `0${minutos}` : `${minutos}`;

    horarioFormatado = `${horaFormatada}:${minutoFormatado}`;
  }
  return horarioFormatado;
}

export function formatarDataStringParaMesCompetencia(data: string): string {
  const splitData = data.split("-");
  const ano = splitData[0];
  const mes = splitData[1];
  const dataFormatada = `${mes}/${ano}`;
  return dataFormatada;
}

export function converterDataBrParaDate(dataBr: string) {
  const partes = dataBr.split("/");
  const data = new Date(Number.parseInt(partes[2]), Number.parseInt(partes[1]) - 1, Number.parseInt(partes[0]));
  return data;
}

export const valoresDiferentes = (a: number, b: number): boolean => Math.abs(a - b) > 0.005;

export function formatarValorMonetarioInputNumerico(valorMonetario: string | number): number {
  if (typeof valorMonetario === "number") {
    return valorMonetario;
  }
  if (!valorMonetario) {
    return 0;
  }

  let valorLimpo = valorMonetario.toString().trim().replace("R$", "");
  valorLimpo = valorLimpo.replaceAll(".", "");
  valorLimpo = valorLimpo.replace(",", ".");

  const valorNumerico = Number.parseFloat(valorLimpo);
  return isNaN(valorNumerico) ? 0 : valorNumerico;
}

export function formatarLocalDateTime(dataParaFormatar: string) {
  const data = new Date(dataParaFormatar);

  if (isNaN(data.getTime())) {
    return "Data inválida";
  }

  const dia = String(data.getDate()).padStart(2, "0");
  const mes = String(data.getMonth() + 1).padStart(2, "0");
  const ano = data.getFullYear();
  const dataFormatada = `${dia}/${mes}/${ano}`;

  const horas = String(data.getHours()).padStart(2, "0");
  const minutos = String(data.getMinutes()).padStart(2, "0");
  const horarioFormatado = `${horas}:${minutos}`;

  return `${dataFormatada} às ${horarioFormatado}`;
}

export const limparCpfCnpj = (valor: string | undefined | null): string => {
  if (!valor) return "";
  return valor.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();
};
